(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-video-feed"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    root.classList.add('bbf-ready');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeVideo;
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      const video = entry.target;
      if (entry.isIntersecting && entry.intersectionRatio > .6 && !reduced && !video.dataset.userPaused && !document.hidden) {
        if (activeVideo && activeVideo !== video) activeVideo.pause();
        activeVideo = video;
        video.play().catch(() => {});
      } else { video.pause(); }
    }), {threshold: [0,.6,.9]});
    root.querySelectorAll('video').forEach(video => {
      observer.observe(video);
      video.addEventListener('play', () => { root.querySelectorAll('video').forEach(other => {if (other !== video) other.pause();}); activeVideo=video; });
    });
    document.addEventListener('visibilitychange', () => { if (document.hidden && activeVideo) activeVideo.pause(); });
    root.addEventListener('click', event => {
      const sound = event.target.closest('[data-sound]');
      if (sound) {const video=sound.closest('.bbf-media').querySelector('video');video.muted=!video.muted;sound.textContent=video.muted?sound.dataset.on:sound.dataset.off;sound.setAttribute('aria-pressed',String(!video.muted));}
      const open=event.target.closest('[data-open]');
      if(open){if(activeVideo)activeVideo.pause();document.getElementById(open.dataset.open).showModal();}
      const close=event.target.closest('[data-close]');if(close)close.closest('dialog').close();
      const tab=event.target.closest('[data-tab]');if(tab){
        root.querySelectorAll('[data-tab]').forEach(button=>{const selected=button===tab;button.setAttribute('aria-selected',String(selected));button.tabIndex=selected?0:-1;document.getElementById(button.dataset.tab).hidden=!selected;});
        if(activeVideo)activeVideo.pause();
        const tabUrl=new URL(location.href); tabUrl.hash=tab.dataset.tab==='bbf-soon'?'coming-soon':''; history.replaceState(null,'',tabUrl);
      }
    });
    root.querySelectorAll('dialog').forEach(dialog=>dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}}));
    root.querySelectorAll('[data-tab]').forEach(button=>button.addEventListener('keydown',event=>{if(['ArrowLeft','ArrowRight','Home','End'].includes(event.key)){event.preventDefault();const tabs=[...root.querySelectorAll('[data-tab]')];const next=event.key==='Home'?tabs[0]:event.key==='End'?tabs.at(-1):tabs[(tabs.indexOf(button)+1)%tabs.length];next.click();next.focus();}}));
    if(location.hash==='#coming-soon'||location.search.includes('customer_posted=true'))root.querySelector('[data-tab="bbf-soon"]')?.click();
    root.querySelectorAll('.bbf-cart-form').forEach(form=>form.addEventListener('submit',async event=>{
      event.preventDefault();const button=form.querySelector('button');if(button.disabled)return;const label=button.textContent;const status=form.closest('.bbf-card').querySelector('.bbf-status');button.disabled=true;button.textContent=root.dataset.adding;status.textContent='';
      try {const response=await fetch(root.dataset.cartAdd,{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});const data=await response.json();if(!response.ok)throw new Error(data.description||root.dataset.error);status.textContent=root.dataset.added;const cartResponse=await fetch(root.dataset.cart+'.js',{headers:{Accept:'application/json'}});if(cartResponse.ok){const cart=await cartResponse.json();root.querySelectorAll('[data-cart-count]').forEach(count=>count.textContent=cart.item_count);}}
      catch(error){status.textContent=error.message||root.dataset.error;}finally{button.disabled=false;button.textContent=label;}
    }));
  }
  document.querySelectorAll('.bb-feed-shell').forEach(init);
  document.addEventListener('shopify:section:load',event=>init(event.target.querySelector('.bb-feed-shell')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
